import { CancelIcon, MonetizationOnIcon } from "../../components/icons";
import { STATUS_DETAILS } from "../../ducks/consts";
import { Container, ListGroup } from "react-bootstrap";
import posAutoatendimentoNumeroPedido from "../../assets/payment-flat-rounded/pos-autoatendimento-numero-pedido.jpg";
import Loading from "../../components/Loading";
import OrderDetailsStatus from "../OrderDetailsStatus";

export default function SelfCheckoutQRCodeStatus({
  shortReference,
  shop,
  cache,
  order,
  status,
}) {
  if (!order || !status) {
    return (
      <Container>
        <div className="d-flex flex-row justify-content-center my-4">
          <h4 className="type-h4">
            <strong>{`Pedido #${shortReference}`}</strong>
          </h4>
        </div>
        <Loading message="Carregando Status Autoatendimento QRCode..." />
      </Container>
    );
  }

  const cancelled = status.find(
    (s) => s.code === STATUS_DETAILS.CANCELLED.code,
  );

  const paid = status.find((s) => s.code === STATUS_DETAILS.CONFIRMED.code);

  return (
    <div>
      <div className="px-3 text-center">
        <div className="d-flex flex-row justify-content-center my-4">
          <h4 className="type-h4">
            <strong>{`Seu pedido #${shortReference} foi realizado com sucesso!`}</strong>
          </h4>
        </div>
        {cancelled && paid && (
          <div className="d-flex flex-column align-items-center totem-status-erro">
            <CancelIcon className="totem-status-icon--sm" />
            <h6 className="type-h6">
              <strong>
                Ops, a loja teve um problema e cancelou seu pedido, dirija-se
                até o caixa para realizar o estorno do pagamento.
              </strong>
            </h6>
          </div>
        )}
        {!cancelled && paid && (
          <div className="d-flex flex-column">
            <div className="d-flex flex-column align-items-center totem-status-ok">
              <MonetizationOnIcon className="totem-status-icon--sm" />
              <h5 className="type-h5 my-2">Pagamento concluido!</h5>
            </div>
            <div className="d-flex flex-row">
              <h5 className="type-h5">
                <strong>
                  <br />
                  <br />
                  Vamos iniciar o preparo do seu pedido e quanto estiver pronto
                  vamos chamar pelo número #{shortReference}
                </strong>
              </h5>
            </div>
          </div>
        )}
        {!cancelled && !paid && (
          <div className="d-flex flex-column">
            <div className="d-flex flex-column mb-4 align-items-center totem-status-pendente">
              <h6 className="type-h6">
                <strong>Pagamento pendente</strong>
                <br />
                <small>siga os passos abaixo</small>
              </h6>
            </div>
            <div className="d-flex flex-row">
              <img
                src={posAutoatendimentoNumeroPedido}
                height="330rem"
                alt="maquininha de cartão"
              />
              <ListGroup variant="flush" className="text-start ms-4">
                <ListGroup.Item className="px-0 py-4">
                  <h6 className="type-h6">
                    <strong>1. </strong>Dirija-se até uma das maquininhas
                  </h6>
                </ListGroup.Item>
                <ListGroup.Item className="px-0 py-4">
                  <h6 className="type-h6">
                    <strong>2. </strong>Digite o número do pedido{" "}
                    <strong>{shortReference}</strong>
                  </h6>
                </ListGroup.Item>
                <ListGroup.Item className="px-0 py-4">
                  <h6 className="type-h6">
                    <strong>3. </strong>Realize o pagamento
                  </h6>
                </ListGroup.Item>
              </ListGroup>
            </div>
          </div>
        )}
      </div>
      <OrderDetailsStatus
        className={"mt-5"}
        shortReference={shortReference}
        cache={cache}
        shop={shop}
        order={order}
        isOrderVisibleInitialValue={false}
      />
    </div>
  );
}
